import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { searchStationHistory } from '../modules/stationHistory';
import { search as searchStations } from '../modules/station';

const mapStateToProps = (state) => {
	let stations = [];
	if (state.lists.stationIds) {
		stations = _.map(state.lists.stationIds, (id) => state.maps.station[id]);
	}
	return {
		stations,
	};
};

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			searchStationHistory,
			searchStations,
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps);
